var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{staticClass:"pa-5"},[(_vm.done)?_c('p',[_vm._v(" 「"+_vm._s(_vm.address)+"」のメルマガ登録を解除しました。 ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }